import { createFileRoute, redirect } from '@tanstack/react-router';
import * as z from 'zod';

/**
 * O aluno usa o mesmo login do revendedor. Essa rota existe apenas para manter a url
 * divulgada no e-mail de boas-vindas funcionando, então ela repassa tudo para o login.
 */
export const Route = createFileRoute('/__public/aluno/login')({
  validateSearch: z.object({
    from: z.literal('v1').optional(),
    reason: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/login', search });
  },
});
